module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.needSlove) ? _c('div', [_vm._l((_vm.solution.children), function(orderItem, indexs) {
    return _c('div', [_c('div', {
      staticClass: "product-detail",
      on: {
        "click": function($event) {
          return _vm.gotoDetail(orderItem, orderItem.id)
        }
      }
    }, [_c('img', {
      staticClass: "product-label",
      attrs: {
        "src": _vm.markImg
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "block-item",
      staticStyle: {
        "padding-top": "10px"
      }
    }, [_c('div', {
      staticClass: "block-address"
    }, [_c('img', {
      staticClass: "largeIcon",
      attrs: {
        "src": _vm.baseurl
      }
    }), _vm._v(" "), (orderItem.template.name) ? _c('div', {
      staticClass: "item-detail"
    }, [_c('span', {
      staticClass: "deep-text-color",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_c('span', [_vm._v("\n                   " + _vm._s(orderItem.template.externalName) + "\n                ")])]), _vm._v(" "), _c('span', {
      staticClass: "light-text-color tiny-font"
    }, [_vm._v("\n                " + _vm._s(orderItem.briefInfoDetail) + "\n              ")]), _vm._v(" "), _c('span', {
      staticClass: "light-text-color tiny-font"
    }, [_vm._v("\n                " + _vm._s(_vm.getRightPu(orderItem.children) !== null ? _vm.getRightPu(orderItem.children).template ? _vm.getRightPu(orderItem.children).template.name : '' : '') + "\n              ")])]) : _c('div', {
      staticClass: "item-detail"
    }, [_vm._m(0, true)])])]), _vm._v(" "), _c('div', {
      staticClass: "price-info"
    }, [(orderItem.standardPrice !== orderItem.formalQuotePrice) ? _c('span', {
      staticClass: "light-text-color tiny-font",
      staticStyle: {
        "text-decoration": "line-through"
      }
    }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(orderItem.standardPrice)))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "research-font-color bold-text"
    }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(orderItem.formalQuotePrice)))])]), _vm._v(" "), _c('div', {
      staticClass: "split-line"
    })])])
  }), _vm._v(" "), (this.solution.standardPrice !== this.solution.formalQuotePrice) ? _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("折后价小记")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end"
    }
  }, [_c('span', {
    staticClass: "light-text-color tiny-font",
    staticStyle: {
      "text-decoration": "line-through"
    }
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(this.solution.standardPrice)))]), _vm._v(" "), _c('span', {
    staticClass: "research-font-color bold-text"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(this.solution.formalQuotePrice)))])])]) : _vm._e(), _vm._v(" "), (!this.$parent.$parent.useDiscountCouponOnly && _vm.orderCouponsValue) ? _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("现金券")]), _vm._v(" "), _c('span', {
    staticClass: "bold-text alert-text"
  }, [_vm._v("- ¥" + _vm._s(_vm.emkt.formatPrice(_vm.orderCouponsValue)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "full-split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("共" + _vm._s(_vm.order.length) + "件商品")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("总计")]), _vm._v(" "), _c('span', {
    staticClass: "research-font-color bold-text",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(this.order.totalPrice)))])])])], 2) : _c('div', [_vm._l((_vm.order), function(orderItem, indexs) {
    return _c('div', _vm._l((orderItem.allData.boSolution.children), function(merchandise, index) {
      return _c('div', {
        staticClass: "product-detail",
        on: {
          "click": function($event) {
            return _vm.gotoDetail(orderItem)
          }
        }
      }, [_c('img', {
        staticClass: "product-label",
        attrs: {
          "src": _vm.markImg
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "block-item",
        staticStyle: {
          "padding-top": "10px"
        }
      }, [_c('div', {
        staticClass: "block-address"
      }, [_c('img', {
        staticClass: "largeIcon",
        attrs: {
          "src": _vm.baseurl
        }
      }), _vm._v(" "), (merchandise.template.name) ? _c('div', {
        staticClass: "item-detail"
      }, [_c('span', {
        staticClass: "deep-text-color",
        staticStyle: {
          "font-size": "12px"
        }
      }, [_c('span', [_vm._v("\n                   " + _vm._s(merchandise.template.name) + "\n                ")])]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color tiny-font"
      }, [_vm._v("\n                " + _vm._s(orderItem.userLabel) + "\n              ")]), _vm._v(" "), _c('span', {
        staticClass: "light-text-color tiny-font"
      }, [_vm._v("\n                " + _vm._s(orderItem.boSignalAnalysis) + "\n              ")])]) : _c('div', {
        staticClass: "item-detail"
      }, [_vm._m(1, true)])])]), _vm._v(" "), _c('div', {
        staticClass: "price-info"
      }, [(merchandise.standardPrice !== merchandise.formalQuotePrice) ? _c('span', {
        staticClass: "light-text-color tiny-font",
        staticStyle: {
          "text-decoration": "line-through"
        }
      }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(merchandise.standardPrice)))]) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "research-font-color bold-text"
      }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(merchandise.formalQuotePrice)))])]), _vm._v(" "), _c('div', {
        staticClass: "split-line"
      })])
    }), 0)
  }), _vm._v(" "), (this.solutionPrice.standardPrice !== this.solutionPrice.formalQuotePrice) ? _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("折后价小记")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end"
    }
  }, [_c('span', {
    staticClass: "light-text-color tiny-font",
    staticStyle: {
      "text-decoration": "line-through"
    }
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(this.solutionPrice.standardPrice)))]), _vm._v(" "), _c('span', {
    staticClass: "research-font-color bold-text"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(this.solutionPrice.formalQuotePrice)))])])]) : _vm._e(), _vm._v(" "), (!this.$parent.$parent.useDiscountCouponOnly && _vm.$parent.$parent.couponDiscount) ? _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("现金券")]), _vm._v(" "), _c('span', {
    staticClass: "bold-text alert-text"
  }, [_vm._v("- ¥" + _vm._s(_vm.emkt.formatPrice(_vm.$parent.$parent.couponDiscount)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "full-split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("共" + _vm._s(_vm.order.length) + "件商品")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("总计")]), _vm._v(" "), _c('span', {
    staticClass: "research-font-color bold-text",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(this.solutionPrice.formalQuotePrice)))])])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "deep-text-color",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_c('span', [_vm._v("\n                   实物返还\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "deep-text-color",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_c('span', [_vm._v("\n                   实物返还\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-269d4cd6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_fc/Order/ServiceProduct.vue
// module id = 1571
// module chunks = 8